
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Splash = lazy(() => import('../pages/splash/page'));
const Home = lazy(() => import('../pages/home/page'));
const NewRequest = lazy(() => import('../pages/new-request/page'));
const Offers = lazy(() => import('../pages/offers/page'));
const Payment = lazy(() => import('../pages/payment/page'));
const Tracking = lazy(() => import('../pages/tracking/page'));
const Orders = lazy(() => import('../pages/orders/page'));
const Wallet = lazy(() => import('../pages/wallet/page'));
const Profile = lazy(() => import('../pages/profile/page'));
const Rating = lazy(() => import('../pages/rating/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Splash />
  },
  {
    path: '/home',
    element: <Home />
  },
  {
    path: '/new-request',
    element: <NewRequest />
  },
  {
    path: '/offers',
    element: <Offers />
  },
  {
    path: '/payment',
    element: <Payment />
  },
  {
    path: '/tracking',
    element: <Tracking />
  },
  {
    path: '/orders',
    element: <Orders />
  },
  {
    path: '/wallet',
    element: <Wallet />
  },
  {
    path: '/profile',
    element: <Profile />
  },
  {
    path: '/rating',
    element: <Rating />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
